export default __webpack_public_path__ + "static/media/city_events.6edeb3c2.svg";